<template lang="html">
    <div class="container">
        <h1>{{shopInfo.name}}</h1>
        <div>
            <ul>
                <li>
                    类型：{{shopInfo.generalName}}
                </li>
                <li>
                    版本：{{shopInfo.versionName}}
                </li>
            </ul>
            <div class="content">
                <img class="logo" :src="shopInfo.images">
                <div v-html="shopInfo.content"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import M from '../assets/common.js'
    import C from '../assets/config.js'
    export default {
        data: () => ({
            urlParams: M.getUrlParams(location.href),
            host: C.host,
            shopList: {},
            shopInfo:{},
            pageOpt: {
                list: {
                    pageNo: 1
                }
            },
            typeName: {}
        }),
        created: function() {
            var self = this;
            M.getAllType("admin", function(data) {
                self.$set('typeName', data);
                self.loadList();
            })
        },
        methods: {
            imgError: function(index) {
                this.$set('bookList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
            },
            // 查询店铺
            loadList: function() {
                let url = this.host + "wuyan/admin/norisuke/",
                    params = {
                        id: this.urlParams.id
                    },
                    self = this;
                M.load(url, params, function(data) {
                    if (data.code) {
                        M.topRightInfoTips({
                            title: data.message
                        })
                    } else {
                        self.$set("shopList", data.data);
                        for(let i=0;i<self.shopList.list.length;i++){
                            if(self.shopList.list[i].id==self.urlParams.id){
                                let one = self.shopList.list[i];
                                one.generalName = self.typeName.general[one.generalId];
                                one.versionName = self.typeName.version[one.versionId];
                                self.$set("shopInfo", one);
                            }
                        }
                    }
                }, 'get');
            }
        }
    }
</script>


<style scoped>
    .container {
        margin-top: 40px
    }
    h1{
        text-align: center;
    }
    ul {
        display: flex;
        margin: 0;
        padding: 0;
    }
    ul li{
        list-style: none;
        padding: 10px 20px;
    }
    .logo{
        width: 260px;
        box-shadow: 0 0 1px 0 #c0c0c0;
        margin-right: 20px;
    }
    .content{
        display: flex;
        align-items: flex-start;
        margin: 20px 0;
    }
</style>


// WEBPACK FOOTER //
// norisukeInfo.vue?271e9794